import React, { useState } from 'react'

export const useLoadImg = (sourcePath = import.meta.env.VITE_API_URL, link, defaultImg = "./images/Not_available.jpg") => {

    const [img, setImg] = useState(null)

    function imageExists(url) {
        return new Promise(resolve => {
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
            img.src = url;
        });
    }

    // Usage:
    imageExists(`${sourcePath}/${link}`).then(exists => {
        setImg(exists ? `${sourcePath}/${link}` : defaultImg);
    });

    return { img }
}
